import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";

const ButtonLink = (props) => {
    return <a styleName="styles.edit" {...props}>{props.text}</a>;
};

ButtonLink.propTypes = {
    text: PropTypes.string

};

export default ButtonLink;
